import { React, useState, useRef, useEffect } from "react";
import ClientLayout from "../../client/components/layout/ClientLayout";
export default function RulesMatchOdd({ onClose }) {
  const [showModal, setShowModal] = useState(false);
  const closeButton = () => {
    setShowModal(false);
  };

  return (
    <>
      <style>
        {`
              .modal-content-style {
                  max-width: 1000px !important;
                  width: 100% !important;
                  max-height: 95vh !important;
                  background-color: #ffff;
                  color: #000
              }
              `}
      </style>

      <div
        class="modal fade show"
        id="modalMarketRules"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalMarketRules"
        style={{ display: "block", paddingLeft: "0px" }}
      >
        <div
          class="modal-dialog modal-lg"
          role="document"
          style={{ top: "13%" }}
        >
          <div class="modal-content modal-content-style">
            <div
              class="modal-header"
              style={{
                borderBottom: "0px",
                padding: "10px",
                background: "white"
              }}
            >
              <div class="modal-title" id="exampleModalLabel">
                Market Rules
              </div>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                style={{
                  color: "white",
                  margin: "-1.1rem -0.7rem -0.9rem auto"
                }}
              >
                <span
                  aria-hidden="true"
                  style={{ color: "#000", opacity: "0.8" }}
                  onClick={onClose}
                >
                  ×
                </span>
              </button>
            </div>
            <div
              id="market-rules-text"
              class="modal-body"
              style={{ textAlign: "center", padding: "8px 0px 0px 0px" }}
            >
              <div class="container-fluid">
                <div data-typeid="" class="row rules-container">
                  <div class="col nopading rules-description">
                    <div>
                      <p style={{ textAlign: "left", fontWeight: "bold" }}>
                        MARKET INFORMATION
                      </p>
                      <p style={{ textAlign: "left" }}>
                        For further information please see{" "}
                        <a
                          href="http://content.betfair.com/aboutus/content.asp?sWhichKey=Rules%20and%20Regulations#undefined.do"
                          target="_blank"
                        >
                          Rules & Regs.
                        </a>
                      </p>
                      <p style={{ textAlign: "left" }}>
                        Who will win this match? At the start of scheduled play
                        all unmatched bets will be cancelled and this market
                        will be turned in-play. This market will not be actively
                        managed therefore it is the responsibility of all
                        customers to manage their own positions. If scores
                        (including a derived target score using the Duckworth
                        Lewis method) are deemed tied at the completion of both
                        innings then all bets on the Match Odds market will be
                        void. Please note there is a separate Tied Match market
                        available for this game. For the avoidance of doubt, if
                        scores are tied at the completion of both innings then
                        any tie breaker that may be used to determine a winner
                        including, but not limited to, bowl outs, Super Overs,
                        one-over eliminators, losing fewer wickets, run rates,
                        coin toss, higher group position does not count for the
                        purposes of this market.
                      </p>
                      <p style={{ textAlign: "left" }}>
                        Customers should be aware that:
                      </p>
                      <p style={{ textAlign: "left", fontWeight: "bold" }}>
                        <li>
                          * Transmissions described as “live” by some
                          broadcasters may actually be delayed and that all
                          in-play matches are not necessarily televised.
                        </li>
                      </p>
                      <p style={{ textAlign: "left", fontWeight: "bold" }}>
                        <li>
                          * The extent of any such delay may vary between
                          customers, depending on the set-up through which they
                          are receiving pictures or data.
                        </li>
                      </p>
                      <p></p>
                    </div>
                  </div>
                </div>
                <div style={{ height: "9px" }}></div>
                <div class="modal-footer" style={{ padding: "0px 0px" }}></div>
                <div>&nbsp;</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
